import React, { useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, } from 'reactstrap';
import { useState } from "react";
import { storageService } from '../../services/storageService';
import { availableCurrencies } from '../../shared/currencyConverter';
export default function GetCurrency(_a) {
    var selectedCurrency = _a.selectedCurrency, onCurrencyChange = _a.onCurrencyChange;
    var _b = useState(false), dropdownOpen = _b[0], setDropdownOpen = _b[1];
    var _c = useState(selectedCurrency || "ISK"), currencySelected = _c[0], setCurrencySelected = _c[1];
    var toggle = function () { return setDropdownOpen(function (prevState) { return !prevState; }); };
    useEffect(function () {
        setCurrencySelected(selectedCurrency);
    }, [selectedCurrency]);
    useEffect(function () {
        storageService.set("selectedCurrency", currencySelected);
        onCurrencyChange(currencySelected);
    }, [currencySelected]);
    useEffect(function () {
        if (!currencySelected || availableCurrencies.indexOf(currencySelected) < 0) {
            setCurrencySelected("ISK");
        }
    }, []);
    return (React.createElement("div", { className: "dropdown" },
        React.createElement(Dropdown, { isOpen: dropdownOpen, toggle: toggle },
            React.createElement(DropdownToggle, { className: "btn btn-secondary dropdown-toggle" },
                currencySelected === "ISK" && React.createElement("span", { itemProp: "priceCurrency" }, "KR ISK"),
                currencySelected === "EUR" && React.createElement(React.Fragment, null,
                    React.createElement("i", { className: "fa-solid fa-euro-sign" }),
                    " ",
                    React.createElement("span", null, "EUR")),
                currencySelected === "USD" && React.createElement(React.Fragment, null,
                    React.createElement("i", { className: "fa-solid fa-dollar-sign" }),
                    " ",
                    React.createElement("span", null, "USD")),
                currencySelected === "GBP" && React.createElement(React.Fragment, null,
                    React.createElement("i", { className: "fa-solid fa-lira-sign" }),
                    " ",
                    React.createElement("span", null, "GBP")),
                currencySelected === "CAD" && React.createElement(React.Fragment, null,
                    React.createElement("i", { className: "fa-solid fa-dollar-sign" }),
                    " ",
                    React.createElement("span", null, "CAD"))),
            React.createElement(DropdownMenu, { itemProp: "makesOffer", itemScope: true, itemType: "https://schema.org/Offer" },
                currencySelected != "ISK" && React.createElement(DropdownItem, { itemProp: "PriceSpecification", itemScope: true, itemType: "https://schema.org/PriceSpecification" },
                    React.createElement("a", { className: "dropdown-item", onClick: function (e) { return setCurrencySelected("ISK"); } },
                        React.createElement("span", { itemProp: "priceCurrency" }, "KR ISK"))),
                currencySelected != "EUR" && React.createElement(DropdownItem, { itemProp: "PriceSpecification", itemScope: true, itemType: "https://schema.org/PriceSpecification" },
                    React.createElement("a", { className: "dropdown-item", onClick: function (e) { return setCurrencySelected("EUR"); } },
                        React.createElement("i", { className: "fa-solid fa-euro-sign" }),
                        " ",
                        React.createElement("span", { itemProp: "priceCurrency" }, "EUR"))),
                currencySelected != "USD" && React.createElement(DropdownItem, { itemProp: "PriceSpecification", itemScope: true, itemType: "https://schema.org/PriceSpecification" },
                    React.createElement("a", { className: "dropdown-item", onClick: function (e) { return setCurrencySelected("USD"); } },
                        React.createElement("i", { className: "fa-solid fa-dollar-sign" }),
                        " ",
                        React.createElement("span", { itemProp: "priceCurrency" }, "USD"))),
                currencySelected != "GBP" && React.createElement(DropdownItem, { itemProp: "PriceSpecification", itemScope: true, itemType: "https://schema.org/PriceSpecification" },
                    React.createElement("a", { className: "dropdown-item", onClick: function (e) { return setCurrencySelected("GBP"); } },
                        React.createElement("i", { className: "fa-solid fa-lira-sign" }),
                        " ",
                        React.createElement("span", { itemProp: "priceCurrency" }, "GBP"))),
                currencySelected != "CAD" && React.createElement(DropdownItem, { itemProp: "PriceSpecification", itemScope: true, itemType: "https://schema.org/PriceSpecification" },
                    React.createElement("a", { className: "dropdown-item", onClick: function (e) { return setCurrencySelected("CAD"); } },
                        React.createElement("i", { className: "fa-solid fa-dollar-sign" }),
                        " ",
                        React.createElement("span", { itemProp: "priceCurrency" }, "CAD")))))));
}
